module.exports = window.__IFENG_INNER_LIBS__["ThreeTerminal_pc_dynamic"];